import axios from 'axios';
import endpoint from './endpoint';
import router from '@/router';

const api = axios.create({
    baseURL: endpoint,
});

api.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('ENSPSID');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // Tell the API which language to return server messages in. The backend
      // SetLocale middleware reads this header (falls back to English).
      try {
        const locale = localStorage.getItem('locale') || 'en';
        config.headers['Accept-Language'] = locale;
      } catch (e) { /* localStorage unavailable */ }
      return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => {
      // A successful reply means we're online — let the offline module know.
      try { window.dispatchEvent(new Event('api-online')); } catch (e) { /* ignore */ }
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('ENSPSID');
        if (router.currentRoute.value.path !== '/login') {
          router.push('/login');
        }
      } else if (!error.response) {
        // No HTTP response = network/connectivity failure.
        try { window.dispatchEvent(new Event('api-network-error')); } catch (e) { /* ignore */ }
      }
      return Promise.reject(error);
    }
);

export default api;
